export const isNumberEven = (number: number): boolean => number % 2 === 0;

// Index starts at 0 so a odd index number is even
export const isIndexEven = (index): boolean => isNumberEven(index + 1);
